<template>
  <VRadioGroup
    class="int-radio-group"
    v-model="autoInvitation"
  >
    <slot name="title">
      <div class="int-radio-text">
        {{ $t('howToNotice') + ':' }}
      </div>
    </slot>
    <VRadio
      v-for="method in variants"
      :value="method.value"
      :label="method.label"
      :key="method.value"
    />
  </VRadioGroup>
</template>
<script>
import { computed, toRefs } from '@vue/composition-api';

export default {
  name: 'CandidateInviteAuto',
  props: {
    value: Boolean,
  },
  setup(props, { emit }) {
    const { value } = toRefs(props);
    const variants = [
      {
        value: true,
        label: 'Приглашать на онлайн интервью автоматически (рекомендуется)',
      },
      {
        value: false,
        label: 'Я сам выберу кого приглашать',
      },
    ];

    return {
      variants,
      autoInvitation: computed({
        get() {
          return value.value;
        },
        set(val) {
          emit('input', val);
        },
      }),
    };
  },
};
</script>
<style lang="scss" scoped>
.int-radio-group {
  border-radius: 0.25rem;
  padding: 0 0 0.25rem 0;
  margin-top: -0.875rem ;
}
.int-radio-item {
  color: #091A35;
  border: 1px solid #fff;
  border-radius: 0.25rem;
  padding: 1.25rem;
  background: #EEF3FA;
  &_active {
    background-color: #fff;
    border-color: transparent;
  }
}
.int-radio-text {
  color: #091A35;
  font-weight: bold;
  line-height: 1.53;
  margin-bottom: 1rem;
}
</style>

<i18n locale="en" lang="yml">

</i18n>
<i18n locale="ru" lang="yml">
howToNotice: Что делать после импорта кандидатов
call: Звонок роботом
</i18n>
